import {isEqual} from 'lodash';

import {AppAction} from '../../../appActions';
import {AnalyticsPanelActionsEnum} from '../analyticsPanelActions';
import {AnalyticsParameters} from './analyticsParameters';

/*
 * Analytics parameters panel.
 */

export function analyticsPanelParametersReducer(
  state: AnalyticsParameters,
  action: AppAction,
): AnalyticsParameters {
  switch (action.type) {
    case AnalyticsPanelActionsEnum.NAVIGATED: {
      const {parameters} = action.payload;

      // The analytics app does not have a unidirectional flow from browser
      // location to rendered components, so guard against infinite
      // loops/recursions.
      if (state && isEqual(state.location, location)) {
        return state;
      }

      return parameters;
    }

    default:
      return state;
  }
}
